export default "__VITE_ASSET__2OXS4giJ__"